<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<el-button @click="addUser" type="primary" v-if="pageAction('scene.add')">
					{{ $t('scene.add') }}
				</el-button>
			</template>
			<el-table :data="appData" border stripe style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="组织" prop="client_name" width="200"></el-table-column>
				<el-table-column label="场景名称" prop="name" min-width="160"></el-table-column>
				<el-table-column label="描述" prop="description" min-width="200" show-overflow-tooltip></el-table-column>
				<el-table-column label="地图" min-width="220">
					<template #default="scope">{{ mapNamesText(scope.row.map_ids) }}</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" width="100">
					<template #default="scope">{{ scope.row.status == 2 ? $t('scene.disabled') : $t('scene.enabled') }}</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="create_at" width="180"></el-table-column>
				<el-table-column label="查看" width="120">
					<template #default="scope">
						<el-button @click="handleView(scope.row)" type="primary" size="small">查看</el-button>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small" v-if="pageAction('scene.edit')">编辑</el-button>
						<el-button @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :current-page="formInline.page" :page-size="formInline.size"
				:page-sizes="[10, 20, 50]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑场景" top="20vh" v-model="addPop" width="50%">
				<el-form :model="addForm" ref="addForm" :rules="rules" label-width="120px">
					<el-form-item label="组织" prop="client_id">
						<el-cascader :options="clientOpts" placeholder="请选择组织" v-model="addForm.client_id"
							style="width:100%" @change="onClientChange"></el-cascader>
					</el-form-item>
					<el-form-item label="场景名称" prop="name">
						<el-input v-model="addForm.name" placeholder="请输入场景名称"></el-input>
					</el-form-item>
					<el-form-item label="描述" prop="description">
						<el-input type="textarea" :rows="3" v-model="addForm.description" placeholder="请输入描述"></el-input>
					</el-form-item>
					<el-form-item label="地图选择" prop="map_ids">
						<el-select multiple filterable v-model="addForm.map_ids" placeholder="请选择平面地图（可多选）"
							style="width:100%">
							<el-option v-for="m in mapOptions" :key="m.id" :label="m.name" :value="m.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="状态" prop="status">
						<el-radio-group v-model="addForm.status">
							<el-radio :label="1">可用</el-radio>
							<el-radio :label="2">停用</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import scene from "../../model/scene";
	import deviceMap from "../../model/deviceMap";
	import client from "../../model/client";
	import { buildClientOptions, findClientPath } from "../../utils/clientCascader";

	export default {
		name: "sceneProject",
		data() {
			return {
				appData: [],
				listCount: 0,
				formInline: {
					page: 1,
					size: 10
				},
				addPop: false,
				clientOpts: [],
				// 全部平面地图（map_type=2）按 id 索引
				allPlannarMaps: [],
				// 当前选中组织下的平面地图选项
				mapOptions: [],
				addForm: {
					id: 0,
					client_id: [],
					name: "",
					description: "",
					map_ids: [],
					status: 1,
				},
				rules: {
					client_id: [{
						required: true,
						message: '请选择组织',
						trigger: "change"
					}],
					name: [{
						required: true,
						message: '请输入场景名称',
						trigger: "blur"
					}],
					map_ids: [{
						required: true,
						type: 'array',
						min: 1,
						message: '请至少选择一个地图',
						trigger: "change"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			await this.loadClient();
			await this.loadMaps();
		},
		methods: {
			pageAction(code) {
				try {
					const acts = JSON.parse(localStorage.getItem('page-action') || '[]');
					return acts.indexOf(code) > -1;
				} catch (e) {
					return true;
				}
			},
			async loadData() {
				const ret = await scene.list({
					page: this.formInline.page,
					size: this.formInline.size
				});
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.formInline.page = 1;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					this.clientOpts = buildClientOptions(ret.data);
				}
			},
			// 拉取全部平面地图（map_type=2）用于下拉与名称解析
			async loadMaps() {
				const ret = await deviceMap.list({ page: 1, size: 1000 });
				if (ret.code === 200) {
					const list = ret.data.list || [];
					this.allPlannarMaps = list.filter(m => m.map_type == 2);
				}
			},
			// 根据选中组织筛选平面地图选项
			refreshMapOptions(clientId) {
				if (!clientId) {
					this.mapOptions = [];
					return;
				}
				this.mapOptions = this.allPlannarMaps.filter(m => m.client_id == clientId);
			},
			onClientChange(val) {
				const cid = Array.isArray(val) ? val[val.length - 1] : val;
				this.refreshMapOptions(cid);
				// 切换组织后清空已选地图，避免跨组织
				this.addForm.map_ids = [];
			},
			mapNamesText(mapIds) {
				if (!mapIds) return '-';
				const ids = String(mapIds).split(',').filter(Boolean);
				if (!ids.length) return '-';
				return ids.map(id => {
					const m = this.allPlannarMaps.find(x => x.id == id);
					return m ? m.name : ('#' + id);
				}).join(' / ');
			},
			addUser() {
				this.addPop = true;
				this.addForm = {
					id: 0,
					client_id: [],
					name: "",
					description: "",
					map_ids: [],
					status: 1,
				};
				this.mapOptions = [];
			},
			handleEdit(row) {
				this.addPop = true;
				const rowData = JSON.parse(JSON.stringify(row));
				const cid = rowData.client_id;
				this.addForm = {
					id: rowData.id,
					client_id: findClientPath(this.clientOpts, cid) || [cid],
					name: rowData.name,
					description: rowData.description,
					map_ids: String(rowData.map_ids || '').split(',').filter(Boolean).map(Number),
					status: rowData.status,
				};
				this.refreshMapOptions(cid);
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm));
						// 组织取级联最后一级
						params.client_id = Array.isArray(params.client_id) ? params.client_id.pop() : params.client_id;
						// 地图数组转逗号分隔字符串
						params.map_ids = (params.map_ids || []).join(',');
						const ret = await scene.save(params);
						if (ret.code === 200) {
							this.addPop = false;
							this.$message.success(ret.message);
							this.loadData();
						} else {
							this.$message.warning(ret.message);
						}
					}
				});
			},
			handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
					confirmButtonText: this.$t('device.confirm'),
					cancelButtonText: this.$t('device.cancel'),
					type: "warning"
				}).then(async () => {
					const ret = await scene.delete({
						id: row.id
					});
					if (ret.code === 200) {
						this.$message.success('操作成功');
						this.loadData();
					} else {
						this.$message.error(ret.message);
					}
				}).catch(() => {});
			},
			handleView(row) {
				this.$router.push({
					path: '/fmap/flat',
					query: {
						map_ids: String(row.map_ids || ''),
						name: row.name,
						client_id: row.client_id
					}
				});
			}
		}
	};
</script>
<style scoped>
	.el-pagination {
		margin: 20px 0px;
		float: right;
	}
</style>
